export default __webpack_public_path__ + "static/media/awscertifiedimg.26d439a8.png";